<template>
  <div class="my-info">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>{{ $t('account.basicInfo') }}</span>
      </div>
      <el-row :gutter="20" class="item-row" v-if="defaultCompany">
        <el-col :offset="5" :span="4" class="item-lable">{{ $t('account.companyName') }}</el-col>
        <el-col :span="15" class="item-value company-value">
          {{defaultCompany.companyName}}
          <span class="auth-company" v-show="defaultCompany.authentFlag === '40'">已认证</span>
          <span @click="showRejectDialog" class="bohui-company" v-show="defaultCompany.authentFlag === '30'">认证驳回</span>
          <span class="auth-company" v-show="defaultCompany.authentFlag === '20'">认证中</span>
          <span @click="toAuthHandle" class="go-auth-company" v-show="defaultCompany.authentFlag === '10'">去认证</span>
        </el-col>
      </el-row>
      <div v-if="userInfo">
        <el-row :gutter="20" class="item-row">
          <el-col :offset="5" :span="4" class="item-lable">{{ $t('account.userName') }}</el-col>
          <el-col :span="15" class="item-value" v-show="!editFlag">{{userInfo.name}}</el-col>
          <el-col :span="15" class="item-value" v-show="editFlag">
            <el-input v-model="dataForm.name" :placeholder="$t('account.userNamePlaceholder')"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="item-row">
          <el-col :offset="5" :span="4" class="item-lable">{{ $t('account.account') }}</el-col>
          <el-col :span="15" class="item-value">{{userInfo.userName}}</el-col>
        </el-row>
        <!-- <el-row :gutter="20" class="item-row">
          <el-col :offset="5" :span="4" class="item-lable">手机号</el-col>
          <el-col :span="15" class="item-value">{{userInfo.mobile}}</el-col>
        </el-row> -->
        <el-row :gutter="20" class="item-row">
          <el-col :offset="5" :span="4" class="item-lable">{{ $t('account.email') }}</el-col>
          <el-col :span="15" class="item-value" v-show="!editFlag">{{userInfo.email}}</el-col>
          <el-col :span="15" class="item-value" v-show="editFlag">
            <el-input v-model="dataForm.email" :placeholder="$t('account.emailPlaceholder')"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="item-row">
          <el-col :offset="5" :span="4" class="item-lable">{{ $t('account.profile') }}</el-col>
          <el-col :span="15" class="item-value">
            <img :src="$store.state.user.headPhoto || defaultImg" alt="" class="user-img"/>
            <el-button style="margin-left: 10px;" type="primary" @click="upLoadImg()">{{ $t('account.uploadPhoto') }}</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="item-row">
          <el-col :span="24" class="item-value" style="text-align: center; margin-top: 20px;">
            <el-button @click="onAuthCompany()">新增企业认证</el-button>
            <el-button v-show="!editFlag" type="primary" @click="openEdit()">{{ $t('update') }}</el-button>
            <el-button v-show="editFlag" type="primary" @click="updateHandle()">{{ $t('common.save') }}</el-button>
            <el-button v-show="editFlag" @click="editFlag=false">{{ $t('cancel') }}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <basic-user-img v-if="imgVisible" ref="imgUpload"></basic-user-img>
    <el-dialog
      title="驳回原因"
      :visible.sync="rejectVisible"
      :show-close="false"
      width="700px"
      :close-on-click-modal="false"
    >
      <p style="margin: 0; font-weight: bold; font-size: 16px">
        非常抱歉，您提交的认证申请由于以下原因被审核员驳回，请知悉：
      </p>
      <p style="margin: 12px 0 0">
        <span
          style="
            display: inline-block;
            width: 100px;
            text-align: right;
            padding-right: 10px;
            font-weight: bold;
          "
          >驳回原因类型: </span
        >{{ defaultCompany.rejectedTypeName }}
      </p>
      <p style="margin: 12px 0 0">
        <span
          style="
            display: inline-block;
            width: 100px;
            text-align: right;
            padding-right: 10px;
            font-weight: bold;
          "
          >驳回内容: </span
        >{{ defaultCompany.rejectedContents }}
      </p>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="rejectVisible = false">关 闭</el-button>
        <el-button
          type="primary"
          @click="toAuthHandle()"
        >重新认证</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BasicUserImg from './basic-user-img'
import Cookies from 'js-cookie'
import {
  USER_AUTH_COMPANY_MODAL,
} from "@/components/authCompany/helper";

export default {
  data () {
    return {
      // userInfo: null,
      // defaultCompany: null,
      rejectVisible: false, // 驳回原因弹窗
      imgVisible: false,
      defaultImg: require('@/assets/img/icon.jpg'),
      editFlag: false,
      dataForm: {
        userName: '',
        name: '',
        mobile: '',
        email: ''
      }
    }
  },
  components: {
    BasicUserImg
  },
  computed: {
    userInfo () {
      let userInfo = {
        userName: this.$store.state.user.userName,
        name: this.$store.state.user.name,
        mobile: this.$store.state.user.mobile,
        email: this.$store.state.user.email,
        headPhoto: this.$store.state.user.headPhoto
      }
      return userInfo
    },
    defaultCompany () {
      let company = null
      company = this.$store.state.user.companyAccountInfo.find(item => {
        return item.companyId === item.defaultCompanyId && item.resignFlag === false
      })
      return company || {}
    }
  },
  created () {
    this.$http.get('/front/consumer/usercenter/custUserCenterInfo', {
      params: {
        appCode: 'PLANTMATE_OFFICIAL',
        companyId: (this.$store.state.user.defaultCompanyId + '') || ''
      }
    })
      .then(({ data: res }) => {
        if (res.code !== 0) {
          return false
        }
        this.$store.dispatch('companyList', res.data.companyAccountInfo || [])
        this.$store.dispatch('setUserInfo', res.data.userInfo)
        Cookies.set('userId', res.data.userInfo.userId)
        Cookies.set('mobile', res.data.userInfo.mobile)
      }).catch(() => { })
  },
  methods: {
    onAuthCompany(){
      console.log('onAuthCompany')
      this.bus.$emit(USER_AUTH_COMPANY_MODAL)
    },
    // 打开驳回原因弹窗
    showRejectDialog () {
      this.rejectVisible = true
    },
    upLoadImg (row) {
      this.imgVisible = true
      this.$nextTick(() => {
        this.$refs.imgUpload.init()
      })
    },
    // 去认证
    toAuthHandle () {
      this.$router.push({
        name: 'enterpriseCertification',
        query: {
          cId: this.defaultCompany.companyId
        }
      })
    },
    openEdit () {
      this.dataForm = this.userInfo
      this.editFlag = true
    },
    // 保存更新用户信息
    updateHandle () {
      this.$http.post(`/front/consumer/user/updateUserInfo`, {
        userId: this.$store.state.user.userId,
        name: this.dataForm.name,
        userNickname: this.dataForm.name,
        birthday: '1976-01-01 00:00:00',
        mail: this.dataForm.email
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.editFlag = false
            this.bus.$emit('refushUserInfo')
          }
        }).catch(() => {
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.my-info{
  .item-row{
    line-height: 40px;
    .item-lable{
      text-align: right;
      font-size: 14px;
      color: #666;
      // height: 20px;
      // line-height: 20px;
    }
    .item-value{
      .user-img{
        background: #F1F1F1;
        width: 110px;
        height: 110px;
      }
    }
    .company-value{
      align-items: center;
      color: #ecc78a;
      .auth-company{
        background-color: #ecc78a;
        color: #333;
        padding: 3px 10px;
        font-size: 10px;
        border-radius: 10px;
      }
      .bohui-company{
        background-color: #ecc78a;
        color: #333;
        padding: 3px 10px;
        font-size: 10px;
        border-radius: 10px;
        cursor: pointer;
      }
      .go-auth-company{
        background-color: #138afd;
        color: #fff;
        padding: 3px 10px;
        font-size: 10px;
        border-radius: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
